export enum SchedulingType {
	PREVENTIVA = 'preventiva',
	CORRETIVA = 'corretiva',
	GUINCHO = 'guincho',
}